import { useRef } from "react";
import styles from "./styles.module.scss";
import NotaName from "assets/icons/nota-name.svg?react";
import { useTranslation } from "react-i18next";

const EmptyPanel = () => {
  const { t } = useTranslation();
  const refWrapper = useRef(null);

  return (
    <div className={styles.wrapper}>
      <div className={`${styles.header}`}>
        <div className={styles.name}>
          <div className={styles.title}>{t("packages.examplePackage")}</div>
          <div className={styles.subTitle}>{t("packages.packageSignature")}</div>
        </div>
        <div ref={refWrapper} className={styles.options}></div>
      </div>
      <div className={styles.package}>
        <div className={styles.background}></div>
        <div className={styles.logo}>
          <NotaName />
          <div className={styles.text}>
            <b>{t("common.selectItem")}</b> {t("common.toStartPreview")}
          </div>
        </div>
      </div>
    </div>
  );
};

{
  /* <div className={styles.empty}>
         <LogoIcon className={styles.logo} /> 
       </div> */
}
export default EmptyPanel;
